module.exports = __webpack_public_path__ + "img/3.331110f6.png";